import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import InfoIcon from 'mdi-react/InfoCircleOutlineIcon';
import InfoPageLink from '../../../info-page-link';

import * as S from './styles';

const AboutReviewsLink = () => {
  const { market, t } = useContext(AppContext);

  return (
    <S.About>
      <InfoIcon size={16} />
      <InfoPageLink id={market.infoPageMap?.aboutReviews}>
        {t('reviews', 'reviews.about-reviews')}
      </InfoPageLink>
    </S.About>
  );
};

export default AboutReviewsLink;
